import { render } from "./tab-game.vue?vue&type=template&id=abc9d8d2"
import script from "./tab-game.vue?vue&type=script&lang=js"
export * from "./tab-game.vue?vue&type=script&lang=js"

import "./tab-game.vue?vue&type=style&index=0&id=abc9d8d2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__